import type { AccountConfig } from '#types/config/pages/account'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    navigation: 'py-6 <md:b-t',
  },
  orderHistory: {
    notificationVariant: 'center'
  },
  address: {
    dialogOptions: {
      type: 'panel'
    }
  },
  creditCards: {
    dialogOptions: {
      type: 'panel'
    }
  }
} satisfies RecursivePartial<AccountConfig>
